import { useMutation } from '@tanstack/react-query';

import {
  shouldRefreshTableAfterBulkRowUpdateError,
  updateTableRows,
  UpdateTableRowsPayload,
} from '../api/portalGateway/updateTableRows';

export type { UpdateTableRowsPayload };

type UseUpdateTableRowParams = {
  mutationSuccessHandler: () => void;
  refreshTableAfterPartialBulkUpdateError?: () => void;
};

export function useUpdateTableRow({
  mutationSuccessHandler,
  refreshTableAfterPartialBulkUpdateError,
}: UseUpdateTableRowParams) {
  const { mutate, error, reset, status } = useMutation({
    mutationFn: updateTableRows,
    onSettled: (_data, mutationError) => {
      if (mutationError == null) {
        mutationSuccessHandler();
        return;
      }
      if (shouldRefreshTableAfterBulkRowUpdateError(mutationError)) {
        refreshTableAfterPartialBulkUpdateError?.();
      }
    },
  });

  return {
    error,
    status,
    reset,
    updateTableRows: (
      contentId: string,
      rowIds: string[],
      data: UpdateTableRowsPayload
    ) => {
      return mutate({ contentId, rowIds, data });
    },
  };
}
